import React from 'react';
import {
    Redirect,
    Route,
} from "react-router-dom";

import { LOCAL_STORAGE_USER_DATA_NAME } from '../constants';


const PrivateRoute = props => {
    const userData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA_NAME) || 'false');
    return userData ? <Route component={props.component} exact={props.exact} path={props.path} /> : <Redirect to="/" />;
}

export default PrivateRoute;